import { CountryResolver } from './country.resolver';
import { CultureResolver } from './culture.resolver';
import { UserLocationPermissionResolver } from './user-location-permission.resolver';

export const SHARED_RESOLVERS = [CountryResolver, CultureResolver, UserLocationPermissionResolver];
